import { useEffect, useContext } from 'preact/hooks';

import { Context } from '@store';

import style from './style.module.scss';

function Snackbar({ tall }) {
  let timer = null;
  const [{ isSnackbarShow }, dispatch] = useContext(Context);

  useEffect(() => {
    if (!isSnackbarShow) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch({ type: 'SET_IS_SNACKBAR_SHOW', payload: false });
    }, 5000);
  }, [isSnackbarShow]);

  const refresh = () => {
    window.location.reload();
  };

  return (
    <div
      class={style.snackbar}
      active={isSnackbarShow ? '' : undefined}
      tall={tall ? '' : undefined}
      role="status"
    >
      <div class={style.label}>A new version of this app is available.</div>
      <button
        class={style.button}
        onClick={refresh}
        type="button"
        tabIndex={isSnackbarShow ? 0 : -1}
        aria-label="Refresh"
      >
        Refresh

      </button>
    </div>
  );
}

export default Snackbar;
